<script>
  import TetradDisplay from './TetradDisplay.svelte';
  import Metaphor from './Metaphor.svelte';
  import Chat from './Chat.svelte';

  export let tetradId="";
  import { i, d, e, f, k, o, r, s, w, more} from './stores.js';
  import {getContext} from 'svelte';
  const db = getContext('firebase').firestore();
  const tetradsRef=db.collection("tetrads")

  let suggestion;

  f.set('flips into?');
  o.set('obsolesces?');
  r.set('retrieves?');
  e.set('enhances?');
  i.set('');
  d.set('');
  s.set('');
  w.set('https://en.wikipedia.org/wiki/Special:Search/');

  if (tetradId){
    tetradsRef.doc(tetradId)
    .onSnapshot(function(doc) {
      //console.log("Current data in tetrad: ", doc.data());
      if (doc.data().e){e.set(doc.data().e)};
      if (doc.data().f){f.set(doc.data().f)};
      if (doc.data().o){o.set(doc.data().o)};
      if (doc.data().r){r.set(doc.data().r)};

      if (doc.data().i){i.set(doc.data().i)};
      if (doc.data().d){d.set(doc.data().d)};
      if (doc.data().s){s.set(doc.data().s)};
      if (doc.data().w){w.set(doc.data().w)};
      k.set(false);
      if (doc.data().k){k.set(doc.data().k)};
    });
  }
  const handleSuggestion = function(event){
    alert("@handleSuggestion = " + event.detail.suggestion);
    suggestion = event.detail.suggestion
  }
  const toggleMore = function(){
    more.set(!$more);
  }
</script>

<div class="whole">
  <div class="tetrad">
    <h1>{$i}
      <a href="{$w}" target="_blank">
      <img src="/wikipedia.png" width="25px" height="25px" alt="link to Wikipedia on this innovation"></a>
    </h1>
    <h2>{$d}</h2>
    <div class="source">from {$s}  </div>
    <TetradDisplay on:suggestion={handleSuggestion}></TetradDisplay>
    <Metaphor></Metaphor>
    <div class="containBut">
      <button class="moreBut" on:click={toggleMore}>Show {$more ? 'Less': 'More'}</button>
    </div>
  </div>
  <div class="chatbox">
    <Chat tetradId="{tetradId}" suggestion="{suggestion}"></Chat>
  </div>
</div>

<style>
  h1, h2, .source {text-align: center;}
  .containBut {width: 100%; margin-bottom: 3rem;}
  .moreBut {margin-left: auto; margin-right: auto;}
  .whole {display: flex; flex-wrap: wrap; }
  .chatbox {max-width: 30em; border: 2px solid black;}
  .tetrad, .chatbox {display: inline;}
  .tetrad {min-width: 50%; margin: 0 auto;}
</style>